import { render } from "./UploadImagensController.vue?vue&type=template&id=3c4381d0"
import script from "./UploadImagensController.vue?vue&type=script&lang=js"
export * from "./UploadImagensController.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__